import { render, staticRenderFns } from "./clientDetails.vue?vue&type=template&id=6c287b9c&scoped=true"
import script from "./clientDetails.vue?vue&type=script&lang=js"
export * from "./clientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c287b9c",
  null
  
)

export default component.exports